// DS: MO3.4
import React from 'react';
import c from 'classnames';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import DetailsDumb from '../DetailsDumb';
import s from './ShopCardDumb.scss';
export const COVER_IMG_HEIGHT = 200;
const ShopCardDumb = ({ className , width , coverImage , title , withAuthorDetails , author , withDescriptionBlock , description , indicatorsSlot , belowCoverImageSlot , detailsRightSlot  })=>{
    const dumboWidth = width - parseInt(s['border-width']) * 2;
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        style: {
            width
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['indicators-slot']
    }, indicatorsSlot), coverImage ? /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: s['cover-image'],
        deviation: coverImage,
        useCoverMode: true,
        width: dumboWidth,
        height: COVER_IMG_HEIGHT
    }) : /*#__PURE__*/ React.createElement("div", {
        style: {
            width: dumboWidth,
            height: COVER_IMG_HEIGHT
        },
        className: c(s['cover-image'], s['empty-cover-image'])
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['below-cover-image-slot']
    }, belowCoverImageSlot), /*#__PURE__*/ React.createElement(DetailsDumb, {
        className: s['details'],
        title: title,
        withAuthorDetails: withAuthorDetails,
        author: author,
        withDescriptionBlock: withDescriptionBlock,
        description: description,
        rightSlot: detailsRightSlot
    }));
};
ShopCardDumb.displayName = 'ShopCardDumb';
export default ShopCardDumb;
